<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-基础设置
  -->
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">


<div class="common-form">通话返佣设置</div>
      <el-form-item :label="'开启单次金额设置'">
        <el-radio v-model="form.is_open" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_open" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="单次金额设置">
        <el-input placeholder="请输入每次扣除金额" type="number" v-model="form.call_money" class="max-w460">
          <template slot="prepend">每次扣除金额</template>
          <template slot="append">金额</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="'开启比列设置'">
        <el-radio v-model="form.is_open2" :label="0">关闭</el-radio>
        <el-radio v-model="form.is_open2" :label="1">开启</el-radio>
      </el-form-item>
      <el-form-item label="比列设置">
        <el-input placeholder="请输入每次扣除金额比例" type="number" v-model="form.call_ratio" class="max-w460">
          <template slot="prepend">每次扣除比例</template>
          <template slot="append">%</template>
        </el-input>
      </el-form-item>

    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import BalanceApi from '@/api/balance.js';
export default {
  data() {
    return {
      form: {
        is_open: 0,
        is_open2: 0,
        call_money:'',
        call_ratio:'',
        // recharge_ratio: 1,
        // remark: '',
        // is_recharge_give: 0,
        // recharge_money: 0,
        // give_money: 0,
        // recharges:[],
      },
      loading: false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    // delRecharge(index){
    //     this.form.recharges.splice(index,1)
    // },
    //   addRecharge(){
    //     this.form.recharges.push({
    //       "sort":50,
    //       "money":0,
    //       "point":0,
    //     });
    //   },
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      BalanceApi.getcallSetting(Params, true)
        .then(data => {
          self.loading = false;
          // if(!data.data.setting.recharges){
          //   data.data.setting.recharges = [];
          // }
          self.form = data.data.setting;

        })
        .catch(error => {});
    },

    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      BalanceApi.savcallSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/callprice/index.vue